import React from "react";
import { t } from "../../../components/CustomComponent.js";

/* ============================================================================
 * HomeFav — ปุ่มหัวใจ ใช้ชุดเดียวกับหน้าทรัพย์ฝั่งแอดมิน (.prop-thumb__fav)
 * ยังไม่กด : วงกลมขาวโปร่ง หัวใจเส้นขอบสีเทา
 * กดแล้ว   : วงกลมทึบไล่เฉดชมพูแดง หัวใจทึบสีขาว
 * ตอนกด    : เด้ง (favPop) + วงกระเพื่อมออกด้านนอก (favRing) ผ่านคลาส is-pop
 * NOTE : ใช้ SVG เพราะฟอนต์ fa-light มีหัวใจแบบโปร่งอย่างเดียว
 * ========================================================================== */
const HEART_PATH =
  "M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z";

export default function HomeFav({ active, pop, onClick }) {
  return (
    <button
      type="button"
      className={`hm-fav ${active ? "is-on" : ""} ${pop ? "is-pop" : ""}`}
      title={t("home_favorites")}
      aria-label={t("home_favorites")}
      aria-pressed={!!active}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <svg viewBox="0 0 512 512" width="18" height="16" aria-hidden="true">
        <path
          d={HEART_PATH}
          fill={active ? "currentColor" : "none"}
          stroke="currentColor"
          strokeWidth={active ? 0 : 44}
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
}
